// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__w17O5","link":"Footer_link__APtuh","separator":"Footer_separator__Wp_Gb"};